import { render, staticRenderFns } from "./statisticsSchool.vue?vue&type=template&id=0746f068&scoped=true&"
import script from "./statisticsSchool.vue?vue&type=script&lang=js&"
export * from "./statisticsSchool.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSchool.vue?vue&type=style&index=0&id=0746f068&lang=stylus&scoped=true&"
import style1 from "./statisticsSchool.vue?vue&type=style&index=1&id=0746f068&lang=stylus&scoped=true&"
import style2 from "./statisticsSchool.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0746f068",
  null
  
)

export default component.exports